const _excluded = ["size"];
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React from "react";
var Apm32 = function Apm32(props) {
  return /*#__PURE__*/ React.createElement(
    "svg",
    props,
    /*#__PURE__*/ React.createElement("path", {
      d: "M9.76 10.77a6.39 6.39 0 0 0 0 2.46h2.899a17.532 17.532 0 0 1 0-2.46H9.76zm.565-1.642h2.525a18.815 18.815 0 0 1 .75-3.019 6.383 6.383 0 0 0-3.275 3.02zm5.202-3.47-.036.085c-.135.323-.317.801-.5 1.404a17.04 17.04 0 0 0-.477 1.981h2.972a17.161 17.161 0 0 0-.476-1.981 15.112 15.112 0 0 0-.537-1.489 6.444 6.444 0 0 0-.946 0zm2.873.452a18.815 18.815 0 0 1 .75 3.019h2.525a6.383 6.383 0 0 0-3.276-3.02zm3.84 4.66h-2.899a17.532 17.532 0 0 1 0 2.46h2.899a6.398 6.398 0 0 0 0-2.46zm-.565 4.102H19.15a18.814 18.814 0 0 1-.75 3.019 6.382 6.382 0 0 0 3.275-3.02zm-5.202 3.47.036-.085c.135-.324.317-.801.5-1.404.172-.563.343-1.23.477-1.981h-2.972c.134.75.305 1.419.476 1.981a15.123 15.123 0 0 0 .537 1.489 6.444 6.444 0 0 0 .946 0zM13.6 17.89a18.814 18.814 0 0 1-.75-3.019h-2.525a6.382 6.382 0 0 0 3.276 3.02zm4.096-4.66a15.903 15.903 0 0 0 0-2.46h-3.392a15.903 15.903 0 0 0 0 2.46h3.392z",
      fill: "currentColor",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4 0a4 4 0 0 0-4 4v16a4 4 0 0 0 4 4h24a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4H4zm4 12a8 8 0 1 1 16 0 8 8 0 0 1-16 0z",
      fill: "currentColor",
    })
  );
};
Apm32.defaultProps = {
  width: "32",
  height: "24",
  viewBox: "0 0 32 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
};
const sizeMap = {
  32: Apm32,
};
export function Apm(_ref) {
  let { size = "32" } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const Icon = sizeMap[size] || sizeMap["32"];
  if (
    process.env.NODE_ENV !== "production" &&
    process.env.NODE_ENV !== "test" &&
    !sizeMap[size]
  ) {
    throw new Error(
      "The '".concat(
        size,
        "' size is not supported by the 'Apm' icon. Please use one of the available sizes: '32'."
      )
    );
  }
  return /*#__PURE__*/ React.createElement(Icon, props);
}
